import {Injectable} from '@angular/core';
import notify from 'devextreme/ui/notify';

const DEFAULT_DISPLAY_TIME_MS = 2000;

const ToastMessageTypes = {
	info: 'info',
	warning: 'warning',
	error: 'error',
	success: 'success',
	custom: 'custom',
};

type NotificationType = keyof typeof ToastMessageTypes;

@Injectable({providedIn: 'root'})
export class NotificationService {
	public success(message: string, displayTime: number = DEFAULT_DISPLAY_TIME_MS): void {
		this.notify(message, ToastMessageTypes.success as NotificationType, displayTime);
	}

	public error(message: string, displayTime: number = DEFAULT_DISPLAY_TIME_MS): void {
		this.notify(message, ToastMessageTypes.error as NotificationType, displayTime);
	}

	public info(message: string, displayTime: number = DEFAULT_DISPLAY_TIME_MS): void {
		this.notify(message, ToastMessageTypes.info as NotificationType, displayTime);
	}

	public warning(message: string, displayTime: number = DEFAULT_DISPLAY_TIME_MS): void {
		this.notify(message, ToastMessageTypes.warning as NotificationType, displayTime);
	}

	public notify(message: string, type: NotificationType, displayTime: number): void {
		notify(
			{
				message,
				closeOnClick: true,
			},
			type,
			displayTime
		);
	}
}
